// Refactor 02/2026 — extrahiert aus AppointmentsPage.js (Studio-geschlossen Banner).
import React from 'react';

export const StudioClosedBanner = ({ currentDate, isStudioOpenOnDate }) => {
  if (isStudioOpenOnDate(currentDate)) return null;

  return (
    <div
      className="bg-red-100 border border-red-300 rounded-lg p-4 mb-4 flex items-center gap-3"
      data-testid="studio-closed-banner"
    >
      <div className="text-red-600 text-lg">🔒</div>
      <div>
        <div className="font-semibold text-red-700">Studio geschlossen</div>
        <div className="text-sm text-red-600">
          An{' '}
          {currentDate.toLocaleDateString('de-DE', {
            weekday: 'long',
            day: 'numeric',
            month: 'long',
          })}{' '}
          ist das Studio laut Öffnungszeiten geschlossen.
        </div>
      </div>
    </div>
  );
};

export default StudioClosedBanner;
